export const signupCopy = {
  title: 'Join Arcadia’s community solar program',
  isAlreadyRegistered: 'Have an Arcadia account? ',
  description:
    'We’ve partnered with Google and EDP Renewables to bring energy savings to thousands of low- and moderate-income households in Ohio. It’s simple to sign up and check your eligibility for savings on your energy bills.',
  buttons: {
    labels: {
      faq: 'View FAQs',
      emailSignUp: 'Sign up with email',
    },
  },
  links: {
    signIn: 'Sign in',
  },
};
